import React from "react";
import { SxProps, TextField } from "@mui/material";
import { useField } from "formik";

type Props = {
  name: string;
  variant: "standard" | "filled" | "outlined" | undefined;
  label: string;
  sx?: SxProps;
  isDisabled?: boolean;
  [rest: string]: any;
};

const FormikTextField = ({
  name,
  variant,
  label,
  sx,
  isDisabled,
  ...rest
}: Props) => {
  const [field, meta] = useField(name);

  const configTextField = {
    ...field,
    ...rest,
  };

  return (
    <TextField
      id={name}
      label={label}
      helperText={meta.touched && meta.error}
      variant={variant}
      sx={sx}
      disabled={isDisabled}
      {...configTextField}
      error={meta.touched && Boolean(meta.error)}
    />
  );
};

export default FormikTextField;
